export async function extractQrTextFromImageUrl(
  imageUrl: string,
): Promise<string | null> {
  try {
    const url = new URL(imageUrl)
    const match = url.pathname.match(/\/QR\/(.+)$/)
    if (match?.[1]) {
      return decodeURIComponent(match[1])
    }
  } catch {
    // invalid URL — fall through to null
  }
  return null
}
